import { String } from "./FormElements/customFields/String"
import { Text } from "./FormElements/customFields/Text"
import { Date } from "./FormElements/customFields/Date"
import { Boolean } from "./FormElements/customFields/Boolean"
import { Select } from "./FormElements/customFields/Select"
import { Checkboxes } from "./FormElements/customFields/Checkboxes"
import { Number } from "./FormElements/customFields/Number"
import { Header } from "./FormElements/customFields/Header"
import { File } from "./FormElements/customFields/File"
import { capitalize } from "lodash"
import {
  ChurchCenterCustomFieldApiRecordWithRelationships,
  DeleteFieldDataRecord,
  UpdateCustomFieldAttributes,
} from "source/myChurchCenter/Profile/types"

export function CustomFieldsForm({
  customFields,
  updateAttributes,
  deleteFieldDataRecord,
}: {
  customFields: ChurchCenterCustomFieldApiRecordWithRelationships[]
  updateAttributes: UpdateCustomFieldAttributes
  deleteFieldDataRecord: DeleteFieldDataRecord
}) {
  return (
    <div className="action-drawer d-f fd-c g-2">
      {customFields.map((customField) => (
        <FieldType
          key={customField.id}
          customField={customField}
          updateAttributes={updateAttributes}
          deleteFieldDataRecord={deleteFieldDataRecord}
        />
      ))}
    </div>
  )
}

function UnsupportedFieldType({
  customField,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
}) {
  const type =
    customField.relationships.field_definition.data.attributes.data_type
  return (
    <div key={customField.id}>
      <p>Unsupported field type: {capitalize(type)}</p>
    </div>
  )
}

const DATA_TYPE_TO_COMPONENT = {
  boolean: Boolean,
  checkboxes: Checkboxes,
  date: Date,
  file: File,
  header: Header,
  number: Number,
  select: Select,
  string: String,
  text: Text,
}

function FieldType({
  customField,
  updateAttributes,
  deleteFieldDataRecord,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
  updateAttributes: UpdateCustomFieldAttributes
  deleteFieldDataRecord: DeleteFieldDataRecord
}) {
  const type =
    customField.relationships.field_definition.data.attributes.data_type

  const Component =
    DATA_TYPE_TO_COMPONENT[type as keyof typeof DATA_TYPE_TO_COMPONENT] ||
    UnsupportedFieldType

  return (
    <Component
      customField={customField}
      updateAttributes={updateAttributes}
      deleteFieldDataRecord={deleteFieldDataRecord}
    />
  )
}
